module.exports = __webpack_public_path__ + "static/VetCode_3-6fb4385b4120d7d6cfaf0a806db833c5.png";